import {FormItemBase} from './form-item-base';

export class FormItemDecimalInput extends FormItemBase<number> {
  controlType = 'decimal';
}
